export enum TagsTypes {
  ORDER_PRODUCTS = "invoice_products",
  CONTRACT_PRODUCTS = "contract_products",
  CLIENTS = "clients",
  LEADS = "leads"
}
